export default "__VITE_ASSET__rEzOnU$y__"